/*
 * Winy Mind Pvt. Ltd.
 * Created by suraj on 23/10/23, 3:45 pm
 * Copyright (c) 2023 . All rights reserved.
 * Last modified 23/10/23, 3:45 pm
 */

package tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_concern.widget

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RequestAnswerData(
    @SerialName("question_id")val questionId:String,
    @SerialName("answer")var answer:String
)
